export const CHANGE_PASS_SUCCESS = "CHANGE_PASS_SUCCESS";
export const CHANGE_PASS_FAIL = "CHANGE_PASS_FAIL";

export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAIL = "FORGOT_PASSWORD_FAIL";

export const CHANGE_ROLE_SUCCESS = "CHANGE_ROLE_SUCCESS";
export const CHANGE_ROLE_FAIL = "CHANGE_ROLE_FAIL";

export const ADD_NEW_USER_SUCCESS = "ADD_NEW_USER_SUCCESS";
export const ADD_NEW_USER_FAIL = "ADD_NEW_USER_FAIL";

export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";

export const ADD_NEW_SECTOR_SUCCESS = "ADD_NEW_SECTOR_SUCCESS";
export const ADD_NEW_SECTOR_FAIL = "ADD_NEW_SECTOR_FAIL";

export const UPDATE_SECTOR_SUCCESS = "UPDATE_SECTOR_SUCCESS";
export const UPDATE_SECTOR_FAIL = "UPDATE_SECTOR_FAIL";

export const DELETE_SECTOR_SUCCESS = "DELETE_SECTOR_SUCCESS";
export const DELETE_SECTOR_FAIL = "DELETE_SECTOR_FAIL";

export const ADD_NEW_PRODUCT_CATEGORY_SUCCESS =
  "ADD_NEW_PRODUCT_CATEGORY_SUCCESS";
export const ADD_NEW_PRODUCT_CATEGORY_FAIL = "ADD_NEW_PRODUCT_CATEGORY_FAIL";

export const UPDATE_PRODUCT_CATEGORY_SUCCESS =
  "UPDATE_PRODUCT_CATEGORY_SUCCESS";
export const UPDATE_PRODUCT_CATEGORY_FAIL = "UPDATE_PRODUCT_CATEGORY_FAIL";

export const DELETE_PRODUCT_CATEGORY_SUCCESS =
  "DELETE_PRODUCT_CATEGORY_SUCCESS";
export const DELETE_PRODUCT_CATEGORY_FAIL = "DELETE_PRODUCT_CATEGORY_FAIL";

export const ADD_NEW_PRODUCT_TYPE_SUCCESS =
  "ADD_NEW_PRODUCT_TYPE_SUCCESS";
export const ADD_NEW_PRODUCT_TYPE_FAIL = "ADD_NEW_PRODUCT_TYPE_FAIL";

export const UPDATE_PRODUCT_TYPE_SUCCESS =
  "UPDATE_PRODUCT_TYPE_SUCCESS";
export const UPDATE_PRODUCT_TYPE_FAIL = "UPDATE_PRODUCT_TYPE_FAIL";

export const DELETE_PRODUCT_TYPE_SUCCESS =
  "DELETE_PRODUCT_TYPE_SUCCESS";
export const DELETE_PRODUCT_TYPE_FAIL = "DELETE_PRODUCT_TYPE_FAIL";

export const ADD_NEW_COMPLIANCE_SUCCESS = "ADD_NEW_COMPLIANCE_SUCCESS";
export const ADD_NEW_COMPLIANCE_FAIL = "ADD_NEW_COMPLIANCE_FAIL";

export const UPDATE_COMPLIANCE_SUCCESS = "UPDATE_COMPLIANCE_SUCCESS";
export const UPDATE_COMPLIANCE_FAIL = "UPDATE_COMPLIANCE_FAIL";

export const DELETE_COMPLIANCE_SUCCESS = "DELETE_COMPLIANCE_SUCCESS";
export const DELETE_COMPLIANCE_FAIL = "DELETE_COMPLIANCE_FAIL";

export const ADD_NEW_PRODUCT_JOURNEY_EVENT_SUCCESS = "ADD_NEW_PRODUCT_JOURNEY_EVENT_SUCCESS";
export const ADD_NEW_PRODUCT_JOURNEY_EVENT_FAIL = "ADD_NEW_PRODUCT_JOURNEY_EVENT_FAIL";

export const UPDATE_PRODUCT_JOURNEY_EVENT_SUCCESS = "UPDATE_PRODUCT_JOURNEY_EVENT_SUCCESS";
export const UPDATE_PRODUCT_JOURNEY_EVENT_FAIL = "UPDATE_PRODUCT_JOURNEY_EVENT_FAIL";

export const DELETE_PRODUCT_JOURNEY_EVENT_SUCCESS = "DELETE_PRODUCT_JOURNEY_EVENT_SUCCESS";
export const DELETE_PRODUCT_JOURNEY_EVENT_FAIL = "DELETE_PRODUCT_JOURNEY_EVENT_FAIL";

export const ADD_NEW_ORGANISATION_SUCCESS = "ADD_NEW_ORGANISATION_SUCCESS";
export const ADD_NEW_ORGANISATION_FAIL = "ADD_NEW_ORGANISATION_FAIL";

export const UPDATE_ORGANISATION_SUCCESS = "UPDATE_ORGANISATION_SUCCESS";
export const UPDATE_ORGANISATION_FAIL = "UPDATE_ORGANISATION_FAIL";

export const DELETE_ORGANISATION_SUCCESS = "DELETE_ORGANISATION_SUCCESS";
export const DELETE_ORGANISATION_FAIL = "DELETE_ORGANISATION_FAIL";

export const ADD_NEW_PRODUCT_MODEL_SUCCESS = "ADD_NEW_PRODUCT_MODEL_SUCCESS";
export const ADD_NEW_PRODUCT_MODEL_FAIL = "ADD_NEW_PRODUCT_MODEL_FAIL";

export const UPDATE_PRODUCT_MODEL_SUCCESS = "UPDATE_PRODUCT_MODEL_SUCCESS";
export const UPDATE_PRODUCT_MODEL_FAIL = "UPDATE_PRODUCT_MODEL_FAIL";

export const DELETE_PRODUCT_MODEL_SUCCESS = "DELETE_PRODUCT_MODEL_SUCCESS";
export const DELETE_PRODUCT_MODEL_FAIL = "DELETE_PRODUCT_MODEL_FAIL";

export const ADD_NEW_PASSPORT_TEMPLATE_SUCCESS =
  "ADD_NEW_PASSPORT_TEMPLATE_SUCCESS";
export const ADD_NEW_PASSPORT_TEMPLATE_FAIL = "ADD_NEW_PASSPORT_TEMPLATE_FAIL"

export const UPDATE_PASSPORT_TEMPLATE_SUCCESS =
  "UPDATE_PASSPORT_TEMPLATE_SUCCESS";
export const UPDATE_PASSPORT_TEMPLATE_FAIL = "UPDATE_PASSPORT_TEMPLATE_FAIL";

export const DELETE_PASSPORT_TEMPLATE_SUCCESS =
"DELETE_PASSPORT_TEMPLATE_SUCCESS";
export const DELETE_PASSPORT_TEMPLATE_FAIL = "DELETE_PASSPORT_TEMPLATE_FAIL";

export const UPDATE_PASSPORT_TEMPLATE_PUBLISH_SUCCESS = "UPDATE_PASSPORT_TEMPLATE_PUBLISH_SUCCESS";
export const UPDATE_PASSPORT_TEMPLATE_PUBLISH_FAIL = "UPDATE_PASSPORT_TEMPLATE_PUBLISH_FAIL";

export const ADD_NEW_ORGANISATION_USER_SUCCESS = "ADD_NEW_ORGANISATION_USER_SUCCESS";
export const ADD_NEW_ORGANISATION_USER_FAIL = "ADD_NEW_ORGANISATION_USER_FAIL";

export const UPDATE_ORGANISATION_USER_SUCCESS = "UPDATE_ORGANISATION_USER_SUCCESS";
export const UPDATE_ORGANISATION_USER_FAIL = "UPDATE_ORGANISATION_USER_FAIL";

export const DELETE_ORGANISATION_USER_SUCCESS = "DELETE_ORGANISATION_USER_SUCCESS";
export const DELETE_ORGANISATION_USER_FAIL = "DELETE_ORGANISATION_USER_FAIL";

export const SAVE_SURVEY_ANSWERS_SUCCESS = "SAVE_SURVEY_ANSWERS_SUCCESS";
export const SAVE_SURVEY_ANSWERS_FAIL = "SAVE_SURVEY_ANSWERS_FAIL";

export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL";

export const ADD_NEW_LICENCE_SUCCESS = "ADD_NEW_LICENCE_SUCCESS";
export const ADD_NEW_LICENCE_FAIL = "ADD_NEW_LICENCE_FAIL";

export const UPDATE_LICENCE_SUCCESS = "UPDATE_LICENCE_SUCCESS";
export const UPDATE_LICENCE_FAIL = "UPDATE_LICENCE_FAIL";

export const ADD_NEW_LICENCE_TYPE_SUCCESS = "ADD_NEW_LICENCE_TYPE_SUCCESS";
export const ADD_NEW_LICENCE_TYPE_FAIL = "ADD_NEW_LICENCE_TYPE_FAIL";

export const UPDATE_LICENCE_TYPE_SUCCESS = "UPDATE_LICENCE_TYPE_SUCCESS";
export const UPDATE_LICENCE_TYPE_FAIL = "UPDATE_LICENCE_TYPE_FAIL";

export const DELETE_LICENCE_SUCCESS = "DELETE_LICENCE_SUCCESS";
export const DELETE_LICENCE_FAIL = "DELETE_LICENCE_FAIL";

export const DELETE_LICENCE_TYPE_SUCCESS = "DELETE_LICENCE_TYPE_SUCCESS";
export const DELETE_LICENCE_TYPE_FAIL = "DELETE_LICENCE_TYPE_FAIL";

export const UPDATE_API_KEY_SUCCESS = "UPDATE_API_KEY_SUCCESS";
export const UPDATE_API_KEY_FAIL = "UPDATE_API_KEY_FAIL";

export const UPDATE_MESSAGE_SUCCESS = "UPDATE_MESSAGE_SUCCESS";
export const UPDATE_MESSAGE_FAIL = "UPDATE_MESSAGE_FAIL";

export const DELETE_MESSAGE_SUCCESS = "DELETE_MESSAGE_SUCCESS";
export const DELETE_MESSAGE_FAIL = "DELETE_MESSAGE_FAIL";

export const ADD_NEW_FACILITY_TYPE_SUCCESS = "ADD_NEW_FACILITY_TYPE_SUCCESS";
export const ADD_NEW_FACILITY_TYPE_FAIL = "ADD_NEW_FACILITY_TYPE_FAIL";

export const UPDATE_FACILITY_TYPE_SUCCESS = "UPDATE_FACILITY_TYPE_SUCCESS";
export const UPDATE_FACILITY_TYPE_FAIL = "UPDATE_FACILITY_TYPE_FAIL";

export const DELETE_FACILITY_TYPE_SUCCESS = "DELETE_FACILITY_TYPE_SUCCESS";
export const DELETE_FACILITY_TYPE_FAIL = "DELETE_FACILITY_TYPE_FAIL";

export const ADD_NEW_FACILITY_SUCCESS = "ADD_NEW_FACILITY_SUCCESS";
export const ADD_NEW_FACILITY_FAIL = "ADD_NEW_FACILITY_FAIL";

export const UPDATE_FACILITY_SUCCESS = "UPDATE_FACILITY_SUCCESS";
export const UPDATE_FACILITY_FAIL = "UPDATE_FACILITY_FAIL";

export const DELETE_FACILITY_SUCCESS = "DELETE_FACILITY_SUCCESS";
export const DELETE_FACILITY_FAIL = "DELETE_FACILITY_FAIL";



